import { DateTime } from 'luxon';
import { ShortRule } from 'shared';

import { legacyProductCardColors } from '../../utils/product-card-colors';

//In the future (when implement admin tool we can fetch names and such from /products)
export interface ServiceClassDO {
  name: string;
  backgroundColor: string;
  color: string;
  productSubType?: string;
  productType: string;
  infoIconColor?: string;
}

export const getServiceClassColor = (productName?: string) => {
  if (!productName) {
    return legacyProductCardColors.DEFAULT;
  }
  const serviceClass = productName.replace(/ /g, '').toUpperCase();
  return (
    legacyProductCardColors[serviceClass as keyof typeof legacyProductCardColors] ?? legacyProductCardColors.DEFAULT
  );
};

const ShortRulesRefundAndRebook = [
  'no-rebook',
  'rebook',
  'rebook-fee',
  'no-refund',
  'refund',
  'refund-fee',
  'free cancel',
  'rebook-fare-difference',
];

export const getOrdinaryShortRules = (shortrules: ShortRule[]): ShortRule[] => {
  return shortrules?.filter(rule => !ShortRulesRefundAndRebook.includes(rule.id) && rule.id !== 'campaign');
};

export const getRefundAndRebookShortRules = (shortrules: ShortRule[]): ShortRule[] => {
  return shortrules.filter(rule => ShortRulesRefundAndRebook.includes(rule.id));
};

export const getDayDifference = (startDate: string, endDate: string) => {
  const originalTimezoneOffset = { setZone: true };
  const startDateTime = DateTime.fromISO(startDate, originalTimezoneOffset);
  const endDateTime = DateTime.fromISO(endDate, originalTimezoneOffset);

  const dayDifference = endDateTime.day - startDateTime.day;

  if (dayDifference < 0) {
    const diff = startDateTime.toUTC().diff(endDateTime.toUTC(), ['months', 'days', 'hours', 'minutes']);

    return diff.days + 1;
  }
  return dayDifference;
};
